<div class="form-row">
  <div class="col" *ngIf="showDatePicker">
    <div [ngStyle]="{ height: showTimePicker ? (small ? '25px' : '38px') : 'auto' }"></div>
    <div class="input-group" [ngClass]="{ 'input-group-sm': small }">
      <input type="text" class="form-control" [ngClass]="{ 'form-control-sm': small }" [placeholder]="'MM' + dateStrSeparator + 'DD' + dateStrSeparator + 'YYYY'" [(ngModel)]="dateStr" (keyup)="dateChange()" />
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" [ngClass]="{ 'btn-sm': small }" type="button" (click)="startDatePicker.toggle()">
          <i class="fa fa-calendar"></i>
        </button>
      </div>
    </div>
    <input
      type="text"
      style="margin: 0px !important; padding: 0px !important; height: 0px !important; border: 0px !important; line-height: 0px !important; font-size: 0px !important;"
      [ngStyle]="{'display': (hideExtraLine ? 'none' : 'inline-block')}"
      ngbDatepicker
      #startDatePicker="ngbDatepicker"
      [firstDayOfWeek]="7"
      [startDate]="dateStruct"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (dateSelect)="dateStruct = $event; triggerOutput(); setDateStr()"
    />
  </div>
  <div class="col" *ngIf="showTimePicker">
    <ngb-timepicker [(ngModel)]="clearInputAfterSelection ? '' : timeStruct" (ngModelChange)="triggerOutput()" [meridian]="meridian" [minuteStep]="minuteStep" [readonlyInputs]="!timePickerEditable" [size]="small ? 'small' : 'large'"> </ngb-timepicker>
  </div>
</div>
